import { Routes, Route } from 'react-router-dom';
import { AuthProvider, RequireAuth } from './auth/AuthContext';
import { Layout } from './components/Layout';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Inbox from './pages/Inbox';
import LeadDetail from './pages/LeadDetail';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <Layout>
                <Inbox />
              </Layout>
            </RequireAuth>
          }
        />
        <Route
          path="/leads/:leadId"
          element={
            <RequireAuth>
              <Layout>
                <LeadDetail />
              </Layout>
            </RequireAuth>
          }
        />
      </Routes>
    </AuthProvider>
  );
}
